import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import Snackbar from "@mui/material/Snackbar";
import { SET_LOADING } from "../redux/action-types";
import FilterButtonForTableHeader from "../components/FilterButtonForTableHeader/FilterButtonForTableHeader";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import AdvisorSideBar from "../components/AdvisorSideBar/AdvisorSideBar";
import CurrentUserInfoTable from "../components/CurrentUserInfoTable/CurrentUserInfoTable";
import FirmUserInfoTable from "../components/FirmUserInfoTable/FirmUserInfoTable";
import FilterPopUp from "../components/FilterPopUp/FilterPopUp";
import FirmFilter from "../components/FirmFilter/FirmFilter";
import AdvisorPortalEditUserInfo from "../components/AdvisorPortalEditUserInfo/AdvisorPortalEditUserInfo";
import AdvisorPortalAddUserInfo from "../components/AdvisorPortalAddUserInfo/AdvisorPortalAddUserInfo";
import AdvisorPortalDeleteInfoConfirmationPopup from "../components/AdvisorPortalDeleteInfoConfirmationPopup/AdvisorPortalDeleteInfoConfirmationPopup";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import {
  getListOfFirmClients,
  editClientFirmDetails,
  resetEditClientFarmDetails,
  deleteAdvisorPortalUser,
  firmAddUser,
  resetAddAdvisorPortalUser,
  getListOfFirmClientsByFirmId,
  resetDeleteAdvisorPortalUser,
} from "../redux/actions";

const BodyWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  background-color: white;
  .tablesContainer {
    padding: 30px 30px;
    width: 100%;
    height: 100%;

    .addUserButton {
      width: 90%;
      text-align: right;

      button {
        border: none;
        background-color: #004576;
        color: white;
        padding: 10px 20px;
        border-radius: 5px;
        cursor: pointer;
      }
    }
    .tableName {
      color: #004576;
      font-weight: 700;
      display: flex;
      align-items: center;
    }
    .table {
      .scrollMessage {
        position: fixed;
        bottom: 10px;
        width: 100%;
        text-align: center;
        padding-top: 20px;
      }
    }
  }
`;

const AdvisorPortalUsersUnderMyFirm = () => {
  const dispatch = useDispatch();
  const {
    listOfFirmClient,
    editFirmClienData,
    deleteAdvisorPortalUserState,
    loading,
    addFirmuser,
    userAccountDetails,
    addMasterAccountWhileEdit,
    removeMasterAccountWhileEdit,
  } = useSelector((state) => state.user);
  const [isClientListLoading, setIsClientListLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const tableNameColumnHeader = useRef(null);
  const [listOfFirmClientState, setListOfFirmClientState] = useState([]);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isFilterPopupVisible, setIsFilterPopupVisible] = useState(false);
  const [editDetails, setEditDetails] = useState({});
  const [isSnackBarVisible, setisSnackBarVisible] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [userToDelete, setUserToDelete] = useState();
  const [userEmailToDelete, setUserEmailToDelete] = useState();
  const [firmValue, setFirmValue] = useState("");
  const [isLoaded, setIsLoaded] = useState(true);
  const [userIdToEdit, setUserIdToEdit] = useState("");

  useEffect(() => {
    dispatch({ type: SET_LOADING, payload: false });
    setIsClientListLoading(false);
    setListOfFirmClientState([
      ...listOfFirmClientState,
      ...(listOfFirmClient?.clients || []),
    ]);
    if (listOfFirmClient?.clients?.length) setPageNumber(pageNumber + 1);
  }, [listOfFirmClient?.clients]);

  useEffect(() => {
    if (!listOfFirmClient?.clients) {
      dispatch({ type: SET_LOADING, payload: true });
      setIsLoaded(false);
      dispatch(getListOfFirmClients(pageNumber, 20, "", [], []));
      setIsClientListLoading(true);
    }
  }, []);

  const handleTableNameClick = () => {
    setIsFilterPopupVisible(true);
  };

  useEffect(() => {
    if (addFirmuser?.isError == false) {
      setIsAddModalVisible(false);
      dispatch(resetAddAdvisorPortalUser());
      setisSnackBarVisible(true);
      setListOfFirmClientState([]);
      setSnackBarMessage("Invitation sent successfully");
      dispatch(getListOfFirmClients(1, 20, "", [], []));
      setPageNumber(1);
      setIsClientListLoading(true);
    } else if (addFirmuser?.isError == true) {
      setisSnackBarVisible(true);
      setSnackBarMessage(addFirmuser?.errorMessage);
    }
  }, [addFirmuser]);

  useEffect(() => {
    if (addMasterAccountWhileEdit || removeMasterAccountWhileEdit) {
      setListOfFirmClientState([]);
      dispatch(getListOfFirmClients(1, 20, "", [], []));
      setPageNumber(1);
      dispatch({ type: SET_LOADING, payload: true });
      setIsLoaded(false);
      setIsClientListLoading(true);
    }
  }, [addMasterAccountWhileEdit, removeMasterAccountWhileEdit]);

  useEffect(() => {
    if (listOfFirmClientState?.length !== 0) {
      let editDetailsTemp = listOfFirmClientState.find(
        (data) => data.userId === userIdToEdit
      );
      setEditDetails(editDetailsTemp);
    }
  }, [listOfFirmClientState]);

  useEffect(() => {
    if (deleteAdvisorPortalUserState?.hasOwnProperty("isError") == false) {
      setIsDeleteModalVisible(false);
      dispatch(resetDeleteAdvisorPortalUser());
      setListOfFirmClientState([]);
      dispatch(getListOfFirmClients(1, 20, "", [], []));
      setPageNumber(1);
      setisSnackBarVisible(true);
      setSnackBarMessage("Data deleted successfully");
      setIsClientListLoading(true);
    }
  }, [deleteAdvisorPortalUserState]);

  useEffect(() => {
    if (editFirmClienData.hasOwnProperty("id")) {
      setIsEditModalVisible(false);
      setListOfFirmClientState([]);
      setPageNumber(1);
      setIsClientListLoading(true);
      dispatch(getListOfFirmClients(1, 20, "", [], []));
      dispatch(resetEditClientFarmDetails());
      setisSnackBarVisible(true);
      setSnackBarMessage("Data edited successfully");
    }
  }, [editFirmClienData]);

  const handleScrollOnTable = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop ===
        e.target.clientHeight + 1 ||
      Math.ceil(e.target.scrollHeight - e.target.scrollTop) ===
        e.target.clientHeight ||
      Math.round(e.target.scrollHeight - e.target.scrollTop) ===
        e.target.clientHeight + 1 ||
      Math.round(e.target.scrollHeight - e.target.scrollTop) ===
        e.target.clientHeight;

    if (bottom && !isClientListLoading) {
      dispatch(getListOfFirmClients(pageNumber, 20, "", [], []));
      setIsClientListLoading(true);
    }
  };

  const handleEditClick = (userId, type) => {
    setUserIdToEdit(userId);
    let editDetailsTemp;
    if (type === "clientData") {
      editDetailsTemp = listOfFirmClientState.find(
        (data) => data.userId === userId
      );
      setEditDetails(editDetailsTemp);
    } else {
      setEditDetails(listOfFirmClient?.loggedUser);
    }
    setIsEditModalVisible(true);
  };

  const handleEditSubmit = (firstName, lastName, email, phoneNo) => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(
      editClientFirmDetails(
        editDetails.userId,
        firstName,
        lastName,
        email,
        phoneNo
      )
    );
  };

  const handleDeleteClick = (userId, userEmail) => {
    setUserToDelete(userId);
    setUserEmailToDelete(userEmail);
    setIsDeleteModalVisible(true);
  };

  const handleDeleteYesButtonClick = () => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(deleteAdvisorPortalUser(userToDelete));
  };

  const handleUserAddClick = (
    firstName,
    lastName,
    email,
    phoneNo,
    ria,
    role,
    masterAccounts
  ) => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(
      firmAddUser(
        firstName,
        lastName,
        email,
        phoneNo,
        ria,
        role,
        masterAccounts
      )
    );
  };

  return (
    <BodyWrapper>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isSnackBarVisible}
        autoHideDuration={3000}
        message={snackBarMessage}
        onClose={() => {
          setisSnackBarVisible(false);
        }}
      />
      {isDeleteModalVisible && (
        <AdvisorPortalDeleteInfoConfirmationPopup
          isModalVisible={isDeleteModalVisible}
          modalOnClose={() => setIsDeleteModalVisible(false)}
          handleYesButtonClick={handleDeleteYesButtonClick}
          userEmailToDelete={userEmailToDelete}
        />
      )}
      {isEditModalVisible && (
        <AdvisorPortalEditUserInfo
          isAdvisorPortalEditUSerInfoModalShow={isEditModalVisible}
          isAdvisorPortalEditUSerInfoModalShowOnClose={() => {
            setIsEditModalVisible(false);
            setEditDetails({});
          }}
          editDetails={editDetails}
          handleEditSubmit={handleEditSubmit}
        />
      )}
      {isAddModalVisible && (
        <AdvisorPortalAddUserInfo
          isAdvisorPortalAddUSerInfoModalShow={isAddModalVisible}
          isAdvisorPortalAddUSerInfoModalShowOnClose={() => {
            setIsAddModalVisible(false);
          }}
          onAddClick={handleUserAddClick}
        />
      )}
      {isFilterPopupVisible && (
        <FilterPopUp
          filterField={"Select Firm"}
          left={tableNameColumnHeader.current.offsetLeft}
          top={tableNameColumnHeader.current.offsetTop}
          crossButtonClick={() => {
            setIsFilterPopupVisible(false);
          }}
          clearClick={() => {}}
          saveClick={() => {
            setIsFilterPopupVisible(false);
            setListOfFirmClientState([]);
            setPageNumber(1);
            dispatch({ type: SET_LOADING, payload: true });
            setIsLoaded(false);
            dispatch(
              getListOfFirmClientsByFirmId(1, 20, "", [], [], firmValue)
            );
          }}
        >
          <FirmFilter
            values={listOfFirmClient?.rias}
            handleFirmChange={(value) => {
              setFirmValue(value);
            }}
          />
        </FilterPopUp>
      )}
      <AdvisorSideBar activeSection={3} />
      <div style={{ marginLeft: "80px" }}>
        <HeaderWithoutLogin
          isLogoClickFromAdvisorPortal={true}
          isHelpButtonVisible={false}
        />
        <div className="tablesContainer">
          <div className="tableName">My Details</div>
          <div className="table">
            <CurrentUserInfoTable
              loggedUser={listOfFirmClient?.loggedUser}
              onEditClick={handleEditClick}
            />
          </div>
          <div className="addUserButton">
            {userAccountDetails?.userType !== "Advisor" ? (
              <button
                onClick={() => {
                  setIsAddModalVisible(true);
                }}
              >
                Add New User
              </button>
            ) : (
              <></>
            )}
          </div>
          <div className="tableName" style={{ marginTop: "30px" }}>
            <div style={{ fontSize: 20 }}>
              RIA:{" "}
              {listOfFirmClient?.rias?.find((data) => data.isSelected === true)
                ?.name || "Tactive"}
            </div>
            <div
              style={{ fontSize: 12, cursor: "pointer" }}
              ref={tableNameColumnHeader}
            >
              &nbsp;
              <FilterButtonForTableHeader
                handleOnClick={handleTableNameClick}
              />
            </div>
          </div>

          <div className="table" style={{ paddingTop: 10 }}>
            <FirmUserInfoTable
              clients={listOfFirmClientState}
              handleScrollOnTable={handleScrollOnTable}
              onEditClick={handleEditClick}
              onDeleteClick={handleDeleteClick}
            />
            <div className="scrollMessage">
              {isClientListLoading
                ? "Loading..."
                : listOfFirmClient?.clients?.length >= 15
                ? "Scroll to load more"
                : listOfFirmClientState.length == 0
                ? "No data found"
                : ""}
            </div>
          </div>
        </div>
      </div>
    </BodyWrapper>
  );
};

export default AdvisorPortalUsersUnderMyFirm;
